module.exports = "<div [ngClass]=\"alerts.length > 0?'grey-layer':''\">\n    <div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable alert-custom\">\n        <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n        <div class=\"alert-message\" [innerHtml]=\"alert.message\"></div>\n        <br>\n        <button class=\"{{ cssClassBtn(alert) }}\" (click)=\"removeAlert(alert)\">OK</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/alert/alert.component.html
// module id = ../../../../../src/app/components/utilita/alert/alert.component.html
// module chunks = main